import { COEFICIENTES_HEIDECKE } from './constants';

export const calcularPorcentagemVidaUtil = (idadeAparente: number, vidaUtil: number): number => {
  if (vidaUtil === 0) return 0;
  return (idadeAparente / vidaUtil) * 100;
};

export const calcularDepreciacao = (
  idadeAparente: number,
  vidaUtil: number,
  coefHeidecke: number,
  valorResidual: number = 0.2
): number => {
  if (idadeAparente === 0) return 0;
  if (vidaUtil === 0) return 0;

  if (idadeAparente >= vidaUtil) {
    return 1.0;
  }

  const r = idadeAparente / vidaUtil;
  const ross = 0.5 * (r + r * r);
  const k = (ross + (1 - ross) * coefHeidecke) * (1 - valorResidual);

  return Math.round(Math.min(Math.max(k, 0), 1) * 1000) / 1000;
};

export const getCoeficienteHeidecke = (estadoConservacao: string): number => {
  return COEFICIENTES_HEIDECKE[estadoConservacao] ?? 0.0252;
};

export const formatarPorcentagem = (valor: number): string => {
  return `${valor.toFixed(2)}%`;
};
